import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService, APP_SETTINGS, AuthService, ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AdminService } from '../admin.service';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, FormsModule],
})
export class MessagesComponent implements OnInit {

  public domain: string = null;
  public adminEmail = '';
  public postDate;
  public selPostDate = '';
  public expireDate;
  public selExpireDate = '';
  public messageContent = '';

  public search4messages;

  public location = null;

  public errorMessage = '';

  public subscriptions: ISubscription[];

  public messageId = '';
  public isAdmin: boolean = false;
  public isMotorradAdmin: boolean = false;
  public isRollsRoyceAdmin: boolean = false;


  constructor(
    private readonly toastService: ToastConfigService,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly adminService: AdminService,
    private readonly analyticsService: AnalyticsService,
    private readonly cdr: ChangeDetectorRef) {
  }

  ngOnInit() {

    if (APP_SETTINGS.isAdmin === 'true') {
      this.isAdmin = true;
    }

    if (APP_SETTINGS.isMotorradAdmin === 'true') {
      this.isMotorradAdmin = true;
    }

    if (APP_SETTINGS.isRollsRoyceAdmin === 'true') {
      this.isRollsRoyceAdmin = true;
    }
    this.messageId = this.route.snapshot.queryParams['id'];
    this.subscriptions = [];
    if (this.messageId) {
      this.subscriptions.push(this.adminService.findMessageById(this.messageId).subscribe(data => {
        if (data) {
          this.location = data['location'];
          this.messageContent = data['description'];
          this.domain = data['isBMW'] ? 'bmw' : data['isMINI'] ? 'mini' : data['isMOTORRAD'] ? 'motorrad' : data['isROLLSROYCE'] ? 'rollsroyce' : '';
        }
        this.cdr.markForCheck();
      }));
    }
  }

  private clearData() {
    this.messageContent = '';
    this.domain = '';
    this.location = '';
  }
  submitMessage() {
    const msgObject = {
      'description': this.messageContent,
      'isBMW': this.domain === 'bmw',
      'isMINI': this.domain === 'mini',
      'isMOTORRAD': this.domain === 'motorrad',
      'isROLLSROYCE': this.domain === 'rollsroyce',
      'location': this.location
    };
    if (this.messageId) {
      const updateMsgObject = {
        ...msgObject,
        'id': this.messageId
      };
      this.subscriptions.push(this.adminService.updateMessage(updateMsgObject).subscribe(data => {
        if (data) {
          this.toastService.popToast('Message Updated');
          this.clearData();
          this.cdr.markForCheck();
        }
      }));
    } else {
      this.subscriptions.push(this.adminService.createNewMessage(msgObject).subscribe(data => {
        if (data) {
          this.toastService.popToast('Message added');
          this.analyticCallMessageAdded();
          this.clearData();
          this.cdr.markForCheck();
        }
      }));
    }
  }

  analyticCallMessageAdded() {
    let userID = this.authService.getUserName();
    this.analyticsService.trackNewMessageAdded(userID, this.domain, this.messageContent, 'added');
  }

}
